var u = (r, p, t = "initial") => p.reduce((n, e) => typeof e == "function" ? e(n) : e?.apply && (!e.when || e.when.includes(t)) ? e.apply(n) : n, r);
export {
  u as applyInputMasks
};

//# sourceMappingURL=input-masks.helper.js.map